const notice = {
  path: 'notice',
  component: resolve => require(['../../../../components/pages/studentUnion/notice'], resolve)
}

export default notice
